import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-276d8712"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-gray",
  style: {"font-size":"medium"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "pl-2" }, "处理流程", -1))
const _hoisted_3 = { class: "card preview" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "avatar show-y" }
const _hoisted_6 = { class: "a-img" }
const _hoisted_7 = {
  class: "name line",
  style: {"--row":"1","width":"50px"}
}
const _hoisted_8 = { class: "title-info" }
const _hoisted_9 = { class: "name" }
const _hoisted_10 = { style: {"color":"#000000"} }
const _hoisted_11 = { class: "badge bg-light font-weight-normal align-super mr-3" }
const _hoisted_12 = { class: "code" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"rgb(108, 108, 108)"} }, "工单编号：", -1))
const _hoisted_14 = { class: "id" }
const _hoisted_15 = { class: "extend-options" }
const _hoisted_16 = {
  key: 0,
  class: "card form"
}
const _hoisted_17 = { class: "card-body p-0" }
const _hoisted_18 = { class: "nav nav-pills flex-column" }
const _hoisted_19 = { class: "nav-item" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 工单主题 ")
const _hoisted_21 = { class: "float-right" }
const _hoisted_22 = { class: "nav-item" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode(" 所属组织 ")
const _hoisted_24 = { class: "float-right" }
const _hoisted_25 = { class: "nav-item" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" 所属设备 ")
const _hoisted_27 = { class: "float-right" }
const _hoisted_28 = { class: "nav-item" }
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 故障类型 ")
const _hoisted_30 = { class: "float-right" }
const _hoisted_31 = { class: "nav-item" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 影响范围 ")
const _hoisted_33 = { class: "float-right" }
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 工单星级 ")
const _hoisted_36 = { class: "float-right" }
const _hoisted_37 = { class: "nav-item" }
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" 故障描述 ")
const _hoisted_39 = { class: "float-right" }
const _hoisted_40 = {
  key: 1,
  class: "card form"
}
const _hoisted_41 = { class: "card-body p-0" }
const _hoisted_42 = { class: "nav nav-pills flex-column" }
const _hoisted_43 = { class: "float-right" }
const _hoisted_44 = {
  key: 0,
  class: "time-label"
}
const _hoisted_45 = { class: "bg-themes" }
const _hoisted_46 = { key: 1 }
const _hoisted_47 = { class: "fas bg-themes" }
const _hoisted_48 = { class: "timeline-item" }
const _hoisted_49 = { class: "time" }
const _hoisted_50 = { class: "timeline-header" }
const _hoisted_51 = { class: "timeline-body" }
const _hoisted_52 = { class: "hyper-text-themes font-weight-bold mr-2" }
const _hoisted_53 = { key: 2 }
const _hoisted_54 = { class: "fas bg-themes" }
const _hoisted_55 = { class: "hyper-text-themes font-weight-bold" }
const _hoisted_56 = { class: "timeline-item" }
const _hoisted_57 = { class: "time" }
const _hoisted_58 = {
  key: 0,
  class: "timeline-header"
}
const _hoisted_59 = {
  key: 1,
  class: "timeline-header"
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode("评论")
const _hoisted_61 = {
  key: 2,
  class: "timeline-header"
}
const _hoisted_62 = /*#__PURE__*/_createTextVNode("图片")
const _hoisted_63 = {
  key: 3,
  class: "timeline-header"
}
const _hoisted_64 = /*#__PURE__*/_createTextVNode("视频")
const _hoisted_65 = {
  key: 4,
  class: "timeline-header"
}
const _hoisted_66 = /*#__PURE__*/_createTextVNode("附件")
const _hoisted_67 = {
  key: 5,
  class: "timeline-body"
}
const _hoisted_68 = ["src"]
const _hoisted_69 = ["onClick"]
const _hoisted_70 = ["innerHTML"]
const _hoisted_71 = {
  key: 0,
  class: "text-right"
}
const _hoisted_72 = { class: "time-label" }
const _hoisted_73 = {
  key: 0,
  class: "actions"
}
const _hoisted_74 = { style: {"position":"relative","width":"100%"} }
const _hoisted_75 = {
  key: 0,
  class: "comment"
}
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "发表评论", -1))
const _hoisted_77 = /*#__PURE__*/_createTextVNode("评论 ")
const _hoisted_78 = /*#__PURE__*/_createTextVNode("图片 ")
const _hoisted_79 = /*#__PURE__*/_createTextVNode("视频 ")
const _hoisted_80 = /*#__PURE__*/_createTextVNode("附件 ")
const _hoisted_81 = { class: "ok-refuse" }
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" 更多")
const _hoisted_83 = /*#__PURE__*/_createTextVNode("转办")
const _hoisted_84 = /*#__PURE__*/_createTextVNode("委派")
const _hoisted_85 = /*#__PURE__*/_createTextVNode("转移")
const _hoisted_86 = /*#__PURE__*/_createTextVNode("催办")
const _hoisted_87 = /*#__PURE__*/_createTextVNode("撤销")
const _hoisted_88 = /*#__PURE__*/_createTextVNode("驳回")
const _hoisted_89 = /*#__PURE__*/_createTextVNode("处理")
const _hoisted_90 = { class: "card" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("选择用户")
const _hoisted_92 = {
  key: 0,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}
const _hoisted_93 = { class: "dialog-footer" }
const _hoisted_94 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_95 = {
  key: 1,
  class: "overlay hyper-text-themes animate__animated animate__fadeIn"
}

export function render(_ctx, _cache) {
  const _component_svg_icon = _resolveComponent("svg-icon")
  const _component_el_avatar = _resolveComponent("el-avatar")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_app_star = _resolveComponent("app-star")
  const _component_Clock = _resolveComponent("Clock")
  const _component_el_icon = _resolveComponent("el-icon")
  const _component_el_image = _resolveComponent("el-image")
  const _component_ChatDotRound = _resolveComponent("ChatDotRound")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")
  const _component_Picture = _resolveComponent("Picture")
  const _component_Camera = _resolveComponent("Camera")
  const _component_Folder = _resolveComponent("Folder")
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")
  const _component_el_dropdown = _resolveComponent("el-dropdown")
  const _component_ArrowDown = _resolveComponent("ArrowDown")
  const _component_Position = _resolveComponent("Position")
  const _component_Share = _resolveComponent("Share")
  const _component_RefreshLeft = _resolveComponent("RefreshLeft")
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_app_select_from_db = _resolveComponent("app-select-from-db")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_picker_items = _resolveComponent("picker-items")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_user_picker = _resolveComponent("user-picker")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_drawer, {
      title: "处理流程",
      modelValue: _ctx.showProcess,
      "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => ((_ctx.showProcess) = $event)),
      "append-to-body": false,
      size: "500px",
      direction: "rtl",
      modal: true,
      "destroy-on-close": ""
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_svg_icon, { name: "stamp" }),
          _hoisted_2
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_avatar, {
                      size: 40,
                      src: _ctx.startUserIcon
                    }, null, 8, ["src"])
                  ]),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.startUserName), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.startUserName) + "发起的" + _toDisplayString(_ctx.processDefinitionName), 1),
                  _createElementVNode("span", _hoisted_11, "v" + _toDisplayString(_ctx.processDefinitionVersion), 1),
                  _createVNode(_component_el_tag, {
                    class: _normalizeClass(_ctx.isRunning ? 'bg-red' : 'bg-green'),
                    size: "small",
                    effect: "light"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.processStatus), 1)
                    ]),
                    _: 1
                  }, 8, ["class"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.workInfo.workCode), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", null, "整体耗时: " + _toDisplayString(_ctx.totalDuration), 1),
                _createElementVNode("div", null, "节点耗时: " + _toDisplayString(_ctx.nodeDuration), 1)
              ])
            ]),
            (_ctx.workInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("ul", _hoisted_18, [
                      _createElementVNode("li", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.workInfo.workSubject), 1)
                      ]),
                      _createElementVNode("li", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.workInfo.fromOrgName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_25, [
                        _hoisted_26,
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.workInfo.projectIdName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _hoisted_29,
                        _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.workInfo.businessIdName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_31, [
                        _hoisted_32,
                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.workInfo.influenceIdName), 1)
                      ]),
                      _createElementVNode("li", _hoisted_34, [
                        _hoisted_35,
                        _createElementVNode("span", _hoisted_36, [
                          _createVNode(_component_app_star, {
                            val: _ctx.workInfo.workStar
                          }, null, 8, ["val"])
                        ])
                      ]),
                      _createElementVNode("li", _hoisted_37, [
                        _hoisted_38,
                        _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.workInfo.workDescribeLaunch), 1)
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("ul", _hoisted_42, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formItems, (form, index) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: "nav-item",
                          key: index
                        }, [
                          _createTextVNode(_toDisplayString(form.title) + " ", 1),
                          _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.formData[form.id]), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])),
            _createElementVNode("div", {
              class: "process",
              style: _normalizeStyle({paddingBottom: !(_ctx.isRunning || _ctx.isAssignee) ? '10px' : '50px'})
            }, [
              _createElementVNode("div", {
                class: "timeline",
                style: _normalizeStyle({marginBottom: !(_ctx.isRunning || _ctx.isAssignee) ? '10px' : '45px'})
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.detailVOList, (detailItem, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (detailItem.activityType === 'time')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                          _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$tools.formatSimpleDate(detailItem.createTime)), 1)
                        ]))
                      : (detailItem.activityType === 'CC')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, [
                              _createVNode(_component_el_avatar, {
                                size: 48,
                                src: _ctx.getAssigneeAvatar(false)
                              }, null, 8, ["src"])
                            ]),
                            _createElementVNode("div", _hoisted_48, [
                              _createElementVNode("span", _hoisted_49, [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_Clock)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(_toDisplayString(_ctx.$tools.formatSimpleTime(detailItem.createTime)), 1)
                              ]),
                              _createElementVNode("h3", _hoisted_50, [
                                _createVNode(_component_el_tag, {
                                  class: "bg-orange",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(detailItem.activityName), 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _createElementVNode("div", _hoisted_51, [
                                _createElementVNode("span", _hoisted_52, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailItem.assigneeList, (assignee, i) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                                      _createTextVNode(_toDisplayString(assignee.title) + "   ", 1)
                                    ], 64))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : (detailItem.activityType === 'userTask')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _createElementVNode("div", _hoisted_54, [
                                _createVNode(_component_el_avatar, {
                                  size: 48,
                                  src: _ctx.getAssigneeAvatar(detailItem.commentVO)
                                }, null, 8, ["src"]),
                                _createElementVNode("div", _hoisted_55, _toDisplayString(detailItem.commentVO.userName), 1)
                              ]),
                              _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("span", _hoisted_57, [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_Clock)
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(_toDisplayString(_ctx.$tools.formatSimpleTime(detailItem.createTime)), 1)
                                ]),
                                (['option', 'system'].includes(detailItem.commentType))
                                  ? (_openBlock(), _createElementBlock("h3", _hoisted_58, [
                                      _createVNode(_component_el_tag, {
                                        class: "bg-orange",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(detailItem.activityName), 1)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (['comment'].includes(detailItem.commentType))
                                    ? (_openBlock(), _createElementBlock("h3", _hoisted_59, [
                                        _createVNode(_component_el_tag, {
                                          class: "bg-gray",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_60
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (['image'].includes(detailItem.commentType))
                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_61, [
                                          _createVNode(_component_el_tag, {
                                            class: "bg-gray",
                                            size: "small"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_62
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : (['video'].includes(detailItem.commentType))
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_63, [
                                            _createVNode(_component_el_tag, {
                                              class: "bg-gray",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _hoisted_64
                                              ]),
                                              _: 1
                                            })
                                          ]))
                                        : (['attachment'].includes(detailItem.commentType))
                                          ? (_openBlock(), _createElementBlock("h3", _hoisted_65, [
                                              _createVNode(_component_el_tag, {
                                                class: "bg-orange",
                                                size: "small"
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_66
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                (detailItem.commentVO)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                      (['image'].includes(detailItem.commentType))
                                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.getJSON(detailItem.commentVO.comments), (imageItem, index1) => {
                                            return (_openBlock(), _createBlock(_component_el_image, {
                                              key: imageItem.key+index1,
                                              src: _ctx.defaultUrl + imageItem.key,
                                              fit: "contain",
                                              "zoom-rate": 1.2,
                                              "preview-src-list": _ctx.previewSrcList,
                                              "initial-index": 1,
                                              lazy: ""
                                            }, null, 8, ["src", "zoom-rate", "preview-src-list"]))
                                          }), 128))
                                        : (['video'].includes(detailItem.commentType))
                                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.getJSON(detailItem.commentVO.comments), (videoItem, index1) => {
                                              return (_openBlock(), _createElementBlock("video", {
                                                style: {"width":"330px"},
                                                key: videoItem.key,
                                                src: _ctx.defaultUrl + videoItem.videoKey,
                                                controls: ""
                                              }, null, 8, _hoisted_68))
                                            }), 128))
                                          : (['attachment'].includes(detailItem.commentType))
                                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.getJSON(detailItem.commentVO.comments), (attachmentItem, index1) => {
                                                return (_openBlock(), _createElementBlock("div", {
                                                  style: {"color":"#3c8dbc","cursor":"pointer"},
                                                  key: attachmentItem.key+index1,
                                                  onClick: $event => (_ctx.downFile(_ctx.defaultUrl + attachmentItem.key, attachmentItem.name))
                                                }, _toDisplayString(index+1) + ". " + _toDisplayString(attachmentItem.name) + " (" + _toDisplayString(_ctx.$tools.formatBytes(attachmentItem.size)) + ") ", 9, _hoisted_69))
                                              }), 128))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                                                _createElementVNode("span", {
                                                  innerHTML: detailItem.commentVO.comments
                                                }, null, 8, _hoisted_70),
                                                (detailItem.endTime && ['option', 'system'].includes(detailItem.commentType))
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                                      _createVNode(_component_el_tag, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(detailItem.endTime), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1024)
                                                    ]))
                                                  : _createCommentVNode("", true)
                                              ], 64))
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ]))
                          : _createCommentVNode("", true)
                  ], 64))
                }), 128)),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("span", {
                    class: _normalizeClass(_ctx.isRunning ? 'bg-red' : 'bg-green')
                  }, _toDisplayString(_ctx.processStatus), 3)
                ])
              ], 4)
            ], 4)
          ]),
          (_ctx.isRunning || _ctx.isAssignee)
            ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                _createElementVNode("div", _hoisted_74, [
                  (_ctx.isRunning)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                        _createVNode(_component_el_dropdown, null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (_ctx.isRunning)
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 0,
                                      command: "comment",
                                      onClick: _cache[0] || (_cache[0] = $event => (_ctx.assigneeDialogCommand('Comments')))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_icon, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_ChatDotRound)
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_77
                                      ]),
                                      _: 1
                                    }))
                                  : _createCommentVNode("", true),
                                _createVNode(_component_el_dropdown_item, {
                                  command: "Photo",
                                  onClick: _cache[2] || (_cache[2] = $event => (_ctx.upload('IMAGE')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      type: "file",
                                      ref: "imageInput",
                                      onChange: _cache[1] || (_cache[1] = (...args) => (_ctx.uploadImage && _ctx.uploadImage(...args))),
                                      style: {"display":"none"},
                                      accept: "image/*",
                                      multiple: ""
                                    }, null, 544),
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Picture)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_78
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, {
                                  command: "Video",
                                  onClick: _cache[4] || (_cache[4] = $event => (_ctx.upload('VIDEO')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      type: "file",
                                      ref: "videoInput",
                                      onChange: _cache[3] || (_cache[3] = (...args) => (_ctx.uploadVideo && _ctx.uploadVideo(...args))),
                                      style: {"display":"none"},
                                      accept: "video/*",
                                      multiple: ""
                                    }, null, 544),
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Camera)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_79
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, {
                                  command: "Attachment",
                                  onClick: _cache[6] || (_cache[6] = $event => (_ctx.upload('FILE')))
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("input", {
                                      type: "file",
                                      ref: "fileInput",
                                      onChange: _cache[5] || (_cache[5] = (...args) => (_ctx.uploadFile && _ctx.uploadFile(...args))),
                                      style: {"display":"none"},
                                      accept: ".zip, .rar, .7z, .doc, .docx, .xls, .xlsx, .pdf, .ppt, .pptx, .txt",
                                      multiple: ""
                                    }, null, 544),
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Folder)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_80
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              link: "",
                              class: "p-2 mr-3"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_icon, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ChatDotRound)
                                  ]),
                                  _: 1
                                }),
                                _hoisted_76
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_81, [
                    (_ctx.isAssignee)
                      ? (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 0,
                          onCommand: _ctx.assigneeDialogCommand
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_dropdown_item, { command: "Assignee" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Position)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_83
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, { command: "Delegate" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_Share)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_84
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_el_dropdown_item, { command: "Rollback" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_icon, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_RefreshLeft)
                                      ]),
                                      _: 1
                                    }),
                                    _hoisted_85
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "p-2 mr-3",
                              type: "warning",
                              plain: "",
                              round: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_82,
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ArrowDown)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["onCommand"]))
                      : _createCommentVNode("", true),
                    (_ctx.isUrging)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          type: "primary",
                          plain: "",
                          round: "",
                          onClick: _cache[7] || (_cache[7] = $event => (_ctx.assigneeDialogCommand('Urging')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_86
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isRunning && _ctx.isStartUser)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 2,
                          type: "primary",
                          plain: "",
                          round: "",
                          onClick: _cache[8] || (_cache[8] = $event => (_ctx.assigneeDialogCommand('Revoke')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_87
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAssignee)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 3,
                          type: "danger",
                          plain: "",
                          round: "",
                          onClick: _cache[9] || (_cache[9] = $event => (_ctx.assigneeDialogCommand('Reject')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_88
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.isAssignee)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 4,
                          type: "primary",
                          round: "",
                          onClick: _cache[10] || (_cache[10] = $event => (_ctx.assigneeDialogCommand('Agree')))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_89
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_dialog, {
            width: "600",
            modelValue: _ctx.assigneeDialogVisible,
            "onUpdate:modelValue": _cache[17] || (_cache[17] = $event => ((_ctx.assigneeDialogVisible) = $event)),
            title: _ctx.assigneeDialogCurrentConfig.title
          }, {
            footer: _withCtx(() => [
              _createElementVNode("span", _hoisted_93, [
                _createVNode(_component_el_button, {
                  disabled: _ctx.isLoading1,
                  onClick: _cache[15] || (_cache[15] = $event => (_ctx.assigneeDialogVisible = false))
                }, {
                  default: _withCtx(() => [
                    _hoisted_94
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createVNode(_component_el_button, {
                  disabled: _ctx.isLoading1,
                  type: "primary",
                  onClick: _cache[16] || (_cache[16] = $event => (_ctx.assigneeDialogSubmit('dialogForm1', 'dialogForm2')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.assigneeDialogCurrentConfig.title), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ])
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_90, [
                _createVNode(_component_el_alert, {
                  class: "mb-3",
                  title: _ctx.assigneeDialogCurrentConfig.remark,
                  type: "success",
                  closable: false,
                  "show-icon": ""
                }, null, 8, ["title"]),
                _createVNode(_component_el_form, {
                  ref: "dialogForm1",
                  model: _ctx.formData,
                  "label-position": "top",
                  rules: _ctx.assigneeDialogForm1Rule
                }, {
                  default: _withCtx(() => [
                    (['Agree'].includes(_ctx.assigneeDialogType))
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.editFormItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_el_form_item, {
                            class: "process-form",
                            label: item.props.placeholder,
                            key: item.name+index,
                            prop: item.id
                          }, {
                            default: _withCtx(() => [
                              (item.title==='PROJECTID')
                                ? (_openBlock(), _createBlock(_component_app_select_from_db, {
                                    key: 0,
                                    modelValue: _ctx.formData[item.id],
                                    "onUpdate:modelValue": $event => ((_ctx.formData[item.id]) = $event),
                                    searchApi: _ctx.projectIdSelectApi
                                  }, null, 8, ["modelValue", "onUpdate:modelValue", "searchApi"]))
                                : _createCommentVNode("", true),
                              (item.title==='ASSIGN')
                                ? (_openBlock(), _createBlock(_component_el_select, {
                                    key: 1,
                                    placeholder: '请选择'+item.props.placeholder,
                                    modelValue: _ctx.formData[item.id],
                                    "onUpdate:modelValue": $event => ((_ctx.formData[item.id]) = $event),
                                    "value-key": "label",
                                    style: {"width":"100%"}
                                  }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.props.options, (option, index) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          label: option.name,
                                          value: option.value,
                                          key: option.value+index
                                        }, null, 8, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1032, ["placeholder", "modelValue", "onUpdate:modelValue"]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["label", "prop"]))
                        }), 128))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["model", "rules"]),
                _createVNode(_component_el_form, {
                  ref: "dialogForm2",
                  "label-position": "top",
                  model: _ctx.assigneeDialogForm,
                  rules: _ctx.assigneeDialogForm2Rule
                }, {
                  default: _withCtx(() => [
                    (['Delegate', 'Assignee'].includes(_ctx.assigneeDialogType))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          class: "pb-1",
                          label: _ctx.assigneeDialogCurrentConfig.title+'用户',
                          prop: "assignedUser"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              size: "default",
                              icon: "Plus",
                              type: "primary",
                              onClick: _cache[11] || (_cache[11] = $event => (_ctx.$refs.userPicker.modalOpen())),
                              round: ""
                            }, {
                              default: _withCtx(() => [
                                _hoisted_91
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_picker_items, {
                              modelValue: _ctx.assigneeDialogForm.assignedUser,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.assigneeDialogForm.assignedUser) = $event))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 8, ["label"]))
                      : _createCommentVNode("", true),
                    (['Rollback'].includes(_ctx.assigneeDialogType))
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 1,
                          class: "pb-1",
                          label: "退回到节点",
                          prop: "rollbackId"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.assigneeDialogForm.rollbackId,
                              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => ((_ctx.assigneeDialogForm.rollbackId) = $event)),
                              class: "w-100",
                              placeholder: "请选择要退回到哪个节点",
                              "value-key": "label"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getRollbackList(_ctx.item.detailVOList), (node, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: node.name+index,
                                    label: node.name,
                                    value: node.value
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_form_item, {
                      class: "pb-1",
                      label: "处理意见",
                      prop: "comments"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          rows: 5,
                          modelValue: _ctx.assigneeDialogForm.comments,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => ((_ctx.assigneeDialogForm.comments) = $event)),
                          placeholder: "请输入处理意见"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["model", "rules"]),
                (_ctx.isLoading1)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_92, [
                      _createVNode(_component_svg_icon, {
                        name: "ali-loading",
                        size: "xl",
                        class: "turn"
                      })
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["modelValue", "title"]),
          (_ctx.isLoading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                _createVNode(_component_svg_icon, {
                  name: "ali-loading",
                  size: "xl",
                  class: "turn"
                })
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_user_picker, {
            ref: "userPicker",
            multiple: false,
            selected: _ctx.assigneeDialogForm.assignedUser,
            onOk: _ctx.userSelected
          }, null, 8, ["selected", "onOk"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}